<template>
  <div>
    <PageLoader v-bind:storage="appLoading" />
    <ServerError v-if="ServerError" />

    <v-snackbar v-model="showSnackBar" color="#3ea56e" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-center fill-height pt-3>
      <v-flex xs12 sm12 md5 lg5 xl4>
        <div class="product-gallery-section">
          <v-card class="modern-card pa-4" elevation="0">
            <div class="main-image-wrapper">
              <template v-if="productPhotos && productPhotos.length > 0">
                <span class="hidden-md-and-up">
                  <v-img v-if="!curImage" :src="mediaURL + productPhotos[0]" max-height="400" contain></v-img>
                  <v-img v-if="curImage" :src="mediaURL + curImage" max-height="400" contain></v-img>
                </span>
                <span class="hidden-sm-and-down">
                  <image-magnifier
                    v-if="!curImage"
                    :src="mediaURL + productPhotos[0]"
                    :zoom-src="mediaURL + productPhotos[0]"
                    width="400"
                    height="400"
                    zoom-width="400"
                    zoom-height="300"
                  ></image-magnifier>
                  <image-magnifier
                    v-if="curImage"
                    :src="mediaURL + curImage"
                    :zoom-src="mediaURL + curImage"
                    width="400"
                    height="400"
                    zoom-width="400"
                    zoom-height="300"
                  ></image-magnifier>
                </span>
              </template>
              <template v-else>
                <v-img src="./../../../assets/noimg.png" max-height="400" contain></v-img>
              </template>
            </div>

            <div class="thumbnail-row mt-4" v-if="productData.photos && productData.photos.length > 0">
              <div
                v-for="(item, i) in productData.photos"
                :key="i"
                class="thumbnail-wrapper"
                :class="{'active-thumb': (curImage ? curImage === item : i === 0)}"
                @click="showImage(item)"
              >
                <v-img :src="mediaURL + item" height="80" contain></v-img>
              </div>
            </div>
          </v-card>

        </div>
      </v-flex>
      <v-flex xs12 sm12 md7 lg7 xl8>
        <v-layout wrap justify-center pt-3>
          <v-flex xs11>
            <v-layout wrap justify-start>
              <v-flex xs12 text-left>
                <span
                  style="
                    font-family: poppinsbold;
                    font-size: 22px;
                    color: #000000;
                  "
                >
                  {{ productData.productname }}
                </span>
              </v-flex>
              <!-- <v-flex xs12 text-left>
                <span
                  style="
                    font-family: poppinslight;
                    font-size: 15px;
                    color: #979797;
                  "
                >
                  {{ productData.description }}
                </span>
              </v-flex> -->
              <v-flex xs12 text-left pt-4>
                <v-btn
                  small
                  depressed
                  color="#3ea56e"
                  tile
                  v-if="productData.offer"
                >
                  <span
                    style="
                      font-family: poppinsmedium;
                      font-size: 12px;
                      color: #ffffff;
                    "
                  >
                    {{ productData.offer }}%
                  </span>
                </v-btn>
              </v-flex>
              <v-flex xs12>
                <v-layout wrap justify-center>
                  <v-flex xs6>
                    <v-layout wrap justify-center>
                      <v-flex xs12 text-left>
                        <span
                          style="
                            font-family: poppinssemibold;
                            font-size: 27px;
                            color: #000000;
                          "
                        >
                          Rs. {{ productData.offerPrice }}
                        </span>
                      </v-flex>
                      <v-flex xs12 text-left>
                        <span
                          class="text-decoration-line-through"
                          style="
                            font-family: poppinsregular;
                            font-size: 16px;
                            color: #ff0000;
                          "
                        >
                          Rs. {{ productData.price }}
                        </span>
                      </v-flex>
                      <!-- <v-flex xs12 text-left>
                        <span
                          class="text-decoration-line-through"
                          style="
                            font-family: poppinsregular;
                            font-size: 16px;
                            color: #ff0000;
                          "
                          v-if="productData.savedamount > 0"
                        >
                          Rs. {{ productData.orginalprice }}
                        </span>

                        <span
                          v-if="productData.instock"
                          class="pl-4"
                          style="
                            font-family: poppinsregular;
                            font-size: 14px;
                            color: #52d25b;
                          "
                        >
                          In Stock
                        </span>
                        <span
                          v-if="!productData.instock"
                          class="pl-4"
                          style="
                            font-family: poppinsregular;
                            font-size: 14px;
                            color: #ff4343;
                          "
                        >
                          Out of Stock
                        </span>
                      </v-flex> -->
                    </v-layout>
                  </v-flex>
                  <v-flex xs6 text-left align-self-center>
                    <v-layout wrap justify-start align-content-center>
                      <!-- <v-flex xs2 text-right px-2 align-self-center>
                        <span
                          style="
                            font-family: poppinsregular;
                            font-size: 14px;
                            color: #8f8f8f;
                          "
                          class="caption"
                        >
                          {{ productData.ratingcount }}
                        </span>
                      </v-flex> -->
                      <v-flex xs8 text-left px-2 align-self-center>
                        <v-rating
                          v-model="productData.rating"
                          color="#FFD341"
                          background-color="#e0e0e0"
                          empty-icon="$ratingFull"
                          half-increments
                          readonly
                          hover
                          small
                        ></v-rating>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>

              <!-- <v-flex xs12 text-left py-4>
                <span
                  v-for="(item, i) in productData.size"
                  :key="i"
                  class="px-1"
                >
                  <v-btn
                    small
                    light
                    rounded
                    depressed
                    outlined
                    @click="changeSize(item)"
                    :ripple="false"
                    :color="
                      productSize.size == item.size ? '#FF0000' : '#919191'
                    "
                    class="sizebutton px-2"
                  >
                    {{ item.size }}
                  </v-btn>
                </span>
              </v-flex> -->
              <!-- <v-flex xs12 text-left v-if="selectedProduct.stock">
                <span
                  style="
                    font-family: poppinsmedium;
                    font-size: 12px;
                    color: #ff0000;
                  "
                >
                  {{ selectedProduct.stock }} Left
                </span>
              </v-flex> -->
              <!-- <v-flex xs12 text-left pt-2 v-if="productSize.stock">
                <v-layout wrap justify-start>
                  <v-flex xs12 text-left>
                    <span
                      style="
                        font-family: poppinssemibold;
                        font-size: 16px;
                        color: #000000;
                      "
                    >
                      COLOR
                    </span>
                  </v-flex>
                </v-layout>
                <v-layout wrap justify-start pt-1 v-if="productSize.color">
                  <v-flex
                    xs2
                    sm2
                    md1
                    lg1
                    xl1
                    align-self-center
                    v-for="(item, i) in productSize.stock"
                    :key="i"
                    px-2
                  >
                    <v-card
                      outlined
                      rounded="50px"
                      class="colorselector"
                      width="40px"
                      @click="selectProduct(item)"
                      :color="
                        selectedProduct.color == item.color ? '#ffebeb' : ''
                      "
                    >
                      <v-layout py-2 wrap align-content-center>
                        <v-flex xs12 text-center>
                          <v-avatar :color="item.color" size="15" />
                        </v-flex>
                        <v-flex xs12 style="padding-top: 2px" text-center>
                          <span
                            style="
                              font-family: poppinsmedium;
                              font-size: 12px;
                              color: #808080;
                            "
                            >{{ item.stock }}</span
                          >
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-flex> -->
              <!-- <v-flex xs12 text-left pt-4>
                <v-layout wrap justify-start>
                  <v-flex xs8 sm7 md6 lg4 xl3 tex-left>
                    <v-text-field
                      ref="promoCode"
                      color="#EC0000"
                      placeholder="Add Promo Code"
                      hide-details
                      outlined
                      dense
                      v-model="promoCode"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs4 sm5 md4 lg3 xl2 px-4 text-left align-self-center>
                    <v-btn :ripple="false" block tile outlined color="#4B4B4B">
                      <span
                        style="
                          font-family: poppinsmedium;
                          font-size: 12px;
                          color: #4b4b4b;
                        "
                      >
                        APPLY
                      </span>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex> -->
              <v-flex xs12 text-left>
                <span
                  style="
                    font-family: poppinslight;
                    font-size: 14px;
                    color: #707070;
                  "
                >
                  {{ productData.description }}
                </span>
              </v-flex>
              <v-flex xs12 text-left pt-10>
                <v-layout wrap>
                  <v-flex xs6>
                    <v-btn
                      small
                      outlined
                      style="text-transform: none"
                      color="green"
                      :to="'/Seller/Product/Edit/' + productData._id"
                    >
                      EDIT
                    </v-btn>
                  </v-flex>
                  <v-flex xs6> </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 sm6 md6 lg7 pl-xl-10 xl8>
                <!-- <v-layout v-if="productData.materialused && productData.materialused.length>0" wrap justify-center pt-4>
          <v-flex xs12 text-left>
            <span
              style="font-family: poppinsbold; font-size: 22px; color: #000000"
            >
              MATERIAL USED
            </span>
          </v-flex>
          <v-flex
            xs12
            text-left
            v-for="(item, i) in productData.materialused"
            :key="i"
          >
            <span
              style="
                font-family: poppinsregular;
                font-size: 14px;
                color: #474747;
              "
            >
              {{ item }}
            </span>
          </v-flex>
        </v-layout> -->
                <v-layout wrap justify-center pt-4>
                  <!-- <v-flex xs12 text-left text-uppercase>
            <span
              style="font-family: poppinsbold; font-size: 22px; color: #000000"
            >
              Retailer
            </span>
          </v-flex>
          <v-flex xs12 text-left >
            <span
              style="
                font-family: poppinsregular;
                font-size: 14px;
                color: #474747;
              "
            >
              {{ productData.seller.organization }},
              {{ productData.seller.locality }}, {{ productData.seller.city }},
              <br />
              {{ productData.seller.state }}, {{ productData.seller.pincode }}
            </span>
          </v-flex> -->
                  <!-- <v-flex xs12 text-left pt-4 v-if="productData.seller">
            <router-link
              :to="
                '/Shops/' +
                productData.seller._id +
                '/' +
                productData.seller.organization
              "
            >
              <v-chip style="cursor: pointer">
                <span
                  style="
                    font-family: poppinssemibold;
                    font-size: 12px;
                    color: #000000;
                  "
                >
                  Visit Profile
                </span>
              </v-chip>
            </router-link>
          </v-flex> -->
                </v-layout>
              </v-flex>
              <!-- <v-flex xs12 pt-4>
                <v-layout wrap justify-start>
                  <v-flex xs6 sm6 md6 lg4 xl2 pr-2>
                    <v-btn
                      :ripple="false"
                      depressed
                      dark
                      block
                      tile
                      color="#FF1313"
                    >
                      <span
                        style="
                          font-family: poppinssemibold;
                          font-size: 12px;
                          text-transform: none;
                        "
                      >
                        <v-icon size="20">mdi-cart-outline</v-icon>
                        Add to Bag
                      </span>
                    </v-btn>
                  </v-flex>
                  <v-flex xs6 sm6 md6 lg4 xl2 pl-2>
                    <v-btn
                      :ripple="false"
                      depressed
                      outlined
                      block
                      tile
                      color="#4B4B4B"
                    >
                      <span
                        style="
                          font-family: poppinssemibold;
                          font-size: 12px;
                          color: #312828;
                          text-transform: none;
                        "
                      >
                        <span>
                          <v-icon size="20">mdi-bookmark-outline</v-icon>
                          Add to wishlist
                        </span>
                      </span>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex> -->
              <v-layout wrap justify-center>
                <v-flex xs12 sm6 md3>
                  <v-btn
                    tile
                    block
                    small
                    outlined
                    color="warning"
                    style="text-transform: none"
                    @click="promoCode()"
                  >
                    <span
                      style="
                          color: #000;
                          font-family: poppinsregular;
                          font-size: 14px;
                        "
                    >
                      Add Promocode
                    </span>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout wrap justify-center>
          <v-layout wrap justify-center>
            <v-flex xs12 v-if="coupon.length > 0">
              <span
                style="   font-family: poppinssemibold;
                            font-size: 20px;
                            color: #000000;"
                >Promo Code</span
              >
            </v-flex>
          </v-layout>
          <v-flex xs12>
            <!-- <PromoCodeList :productData="productData" /> -->
            <v-layout wrap justify-center>
              <v-flex xs12 v-for="(item, i) in coupon" :key="i">
                <v-layout wrap justify-center py-5 pa-2>
                  <v-flex xs12>
                    <v-layout wrap>
                      <v-flex xs6 sm3>
                        <v-layout wrap justify-center>
                          <v-flex text-left xs12>
                            <span
                              style="
                            color: #8d8d8d;
                            font-family: opensanslight;
                            font-size: 14px;
                          "
                            >
                              Promo Code
                            </span>
                          </v-flex>
                          <v-flex text-left xs12>
                            <span
                              style="font-family: opensansbold; font-size: 20px"
                            >
                              {{ item.promoCode }}
                            </span>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs6 sm3 md3>
                        <v-layout wrap justify-center>
                          <v-flex text-left xs12>
                            <span
                              style="  color: #8d8d8d;
                            font-family: opensanslight;
                            font-size: 14px;   "
                            >
                              Discount Percentage
                            </span>
                          </v-flex>
                          <v-flex text-left xs12>
                            <span
                              style="font-family: opensanslight;
                          font-size: 16px;
                          color: #000000;"
                            >
                              {{ item.discountPercentage }} %
                            </span>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs6 sm3 md3>
                        <v-layout wrap justify-center>
                          <v-flex text-left xs12>
                            <span
                              style="  color: #8d8d8d;
                            font-family: opensanslight;
                            font-size: 14px;   "
                            >
                              From Date
                            </span>
                          </v-flex>
                          <v-flex text-left xs12>
                            <span
                              style="font-family: opensanslight;
                          font-size: 16px;
                          color: #000000;"
                            >
                              {{ item.validFromDate.slice(0, 10) }}
                            </span>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs6 sm3 md3>
                        <v-layout wrap justify-center>
                          <v-flex text-left xs12>
                            <span
                              style="  color: #8d8d8d;
                            font-family: opensanslight;
                            font-size: 14px;   "
                            >
                              To Date
                            </span>
                          </v-flex>
                          <v-flex text-left xs12>
                            <span
                              style="font-family: opensanslight;
                          font-size: 16px;
                          color: #000000;"
                            >
                              {{ item.validToDate.slice(0, 10) }}
                            </span>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-layout wrap justify-center pt-4>
                    <v-flex xs6 sm5 md5>
                      <v-layout wrap justify-center>
                        <v-flex text-left xs12>
                          <span
                            style="  color: #8d8d8d;
                            font-family: opensanslight;
                            font-size: 14px;   "
                          >
                            Description
                          </span>
                        </v-flex>
                        <v-flex text-left xs12>
                          <span
                            style="font-family: opensanslight;
                          font-size: 16px;
                          color: #000000;"
                          >
                            {{ item.description }}
                          </span>
                        </v-flex>
                      </v-layout>
                    </v-flex>

                    <v-flex xs2 sm2 md2 pt-4>
                      <v-switch
                        :disabled="
                          item.status == 'Pending' ||
                          item.status == 'Updated' ||
                          item.status == 'Rejected'
                            ? true
                            : false
                        "
                        v-model="item.status"
                        true-value="Active"
                        false-value="Inactive"
                        color="#5DC57C"
                        hide-details
                        :ripple="false"
                        class="statusKey"
                        :loading="statusLoading"
                        @click="changePromoStatus(item)"
                      >
                        <template slot="label">
                          <span
                            style="
                        color: #000000;
                        font-family: opensanssemibold;
                        font-size: 16px;
                      "
                          >
                            {{ item.status }}
                          </span>
                        </template>
                      </v-switch>
                    </v-flex>
                    <v-flex xs3 sm2 md2 lg2 xl2 pt-4>
                      <v-btn
                        tile
                        block
                        small
                        outlined
                        color="warning"
                        style="text-transform: none"
                        @click="editItem(item)"
                      >
                        <span
                          style="
                          color: #000;
                          font-family: poppinsregular;
                          font-size: 14px;
                        "
                        >
                          <v-icon left>mdi-pencil</v-icon>
                          Edit
                        </span>
                      </v-btn>
                    </v-flex>
                    <v-flex xs1 pt-4>
                      <v-dialog v-model="item.deleteDialogue" width="400">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-on="on" v-bind="attrs">mdi-delete</v-icon>
                        </template>
                        <v-card>
                          <v-layout pa-4 wrap justify-center>
                            <v-flex xs12 py-5>
                              <span
                                style="
                color: #000000;
                font-family: opensanssemibold;
                font-size: 18px;
              "
                                >Do you want to delete this promo code ?</span
                              >
                            </v-flex>
                            <v-flex xs6 px-2>
                              <v-btn
                                tile
                                block
                                depressed
                                dark
                                color="#ff1313"
                                @click="deletePromo(item)"
                              >
                                <span
                                  style="font-family: poppinsregular; font-size: 14px"
                                >
                                  Yes
                                </span>
                              </v-btn>
                            </v-flex>
                            <v-flex xs6 px-2>
                              <v-btn
                                tile
                                block
                                depressed
                                dark
                                color="#1BD93B"
                                @click="item.deleteDialogue = false"
                              >
                                <span
                                  style="font-family: poppinsregular; font-size: 14px"
                                >
                                  No
                                </span>
                              </v-btn>
                            </v-flex>
                          </v-layout>
                        </v-card>
                      </v-dialog>
                    </v-flex>
                    <v-flex xs2 sm2 md2 pt-4 text-left>
                      <span
                        v-if="
                          item.status == 'Pending' ||
                            item.status == 'Updated' ||
                            item.status == 'Rejected'
                        "
                      >
                        <v-hover v-slot="{ hover }">
                          <v-card flat>
                            <v-icon color="red" style="cursor:pointer"
                              >mdi-information</v-icon
                            >
                            <div v-if="hover">
                              <v-card flat color="red">
                                <v-layout wrap justify-center px-2>
                                  <v-flex xs12>
                                    <span
                                      style="color:white; font-family: opensanssemibold;font-size: 14px;"
                                      v-if="item.status == 'Rejected'"
                                      >{{ item.reason }}</span
                                    >
                                    <span
                                      style="color:white; font-family: opensanssemibold;font-size: 14px;"
                                      v-if="
                                        item.status == 'Pending' ||
                                          item.status == 'Updated'
                                      "
                                      >Awaiting for admin approvel</span
                                    >
                                  </v-flex>
                                </v-layout>
                              </v-card>
                            </div>
                          </v-card>
                        </v-hover>
                      </span>
                    </v-flex>
                  </v-layout>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-dialog v-model="editDialog" width="600" persistent>
              <v-card>
                <v-layout wrap justify-center pa-2>
                  <v-flex xs12>
                    <v-card tile flat>
                      <v-layout wrap justify-center>
                        <v-flex xs12 text-left>
                          <span
                            style="
                  font-family: poppinsmedium;
                  font-size: 18px;
                  color: #393939;
                "
                          >
                            Add Promo Code
                          </span>
                        </v-flex>
                      </v-layout>
                      <v-layout
                        wrap
                        justify-center
                        pt-4
                        style="font-size: 14px; color: #ababab"
                      >
                        <v-flex xs12 sm12 text-left px-2>
                          <span class="pl-3">Promo Code </span>
                          <v-text-field
                            ref="Promo Code"
                            color="#828282"
                            placeholder="Promo Code"
                            outlined
                            dense
                            v-model="editingitem.promoCode"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 text-left px-2>
                          <span class="pl-3"> Description </span>
                          <v-text-field
                            ref="Description"
                            color="#828282"
                            placeholder="Description"
                            outlined
                            dense
                            v-model="editingitem.description"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 text-left px-2>
                          <span class="pl-3"> Discount Percentage </span>
                          <v-text-field
                            ref="Discount Percentage"
                            color="#828282"
                            placeholder="Discount Percentage"
                            outlined
                            dense
                            v-model="editingitem.discountPercentage"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 text-left px-2>
                          <span class="pl-3"> From Date </span>
                          <v-menu
                            ref="menu"
                            v-model="menu"
                            :close-on-content-click="false"
                            :return-value.sync="editingitem.validFromDate"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="editingitem.validFromDate"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                outlined
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="editingitem.validFromDate"
                              no-title
                              scrollable
                            >
                              <v-spacer></v-spacer>
                              <v-btn text color="primary" @click="menu = false">
                                Cancel
                              </v-btn>
                              <v-btn
                                text
                                color="primary"
                                @click="
                                  $refs.menu.save(editingitem.validFromDate)
                                "
                              >
                                OK
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-flex>
                        <v-flex xs12 sm6 text-left px-2>
                          <span class="pl-3"> To Date </span>
                          <v-menu
                            ref="menu1"
                            v-model="menu1"
                            :close-on-content-click="false"
                            :return-value.sync="editingitem.validToDate"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="editingitem.validToDate"
                                outlined
                                readonly
                                v-bind="attrs"
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="editingitem.validToDate"
                              no-title
                              scrollable
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                text
                                color="primary"
                                @click="menu1 = false"
                              >
                                Cancel
                              </v-btn>
                              <v-btn
                                text
                                color="primary"
                                @click="
                                  $refs.menu1.save(editingitem.validToDate)
                                "
                              >
                                OK
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-flex>
                      </v-layout>
                      <v-layout wrap justify-center>
                        <v-flex xs6 px-2>
                          <v-btn
                            :ripple="false"
                            depressed
                            block
                            tile
                            color="#F9F9F9"
                            @click="editDialog = false"
                          >
                            <span
                              style="
                    font-family: poppinssemibold;
                    font-size: 12px;
                    color: #000;
                    text-transform: none;
                  "
                            >
                              Cancel
                            </span>
                          </v-btn>
                        </v-flex>
                        <v-flex xs6 px-2>
                          <v-btn
                            :ripple="false"
                            depressed
                            block
                            tile
                            color="#3ea56e"
                            @click="editPromoCode()"
                          >
                            <span
                              style="
                    font-family: poppinssemibold;
                    font-size: 12px;
                    color: #fff;
                    text-transform: none;
                  "
                            >
                              Save
                            </span>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-dialog>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout wrap>
      <!-- <v-flex xs12 sm6 md6 lg5 xl4>
        <v-chip-group column>
          <v-chip v-for="(item, i) in productData.tags" :key="i">
            {{ item }}
          </v-chip>
        </v-chip-group>
      </v-flex> -->
    </v-layout>
    <v-dialog v-model="dialog" width="600" persistent>
      <v-card>
        <v-layout wrap justify-center pa-2>
          <v-flex xs12>
            <v-card tile flat>
              <v-layout wrap justify-center>
                <v-flex xs12 text-left>
                  <span
                    style="
                  font-family: poppinsmedium;
                  font-size: 18px;
                  color: #393939;
                "
                  >
                    Add Promo Code
                  </span>
                </v-flex>
              </v-layout>
              <v-layout
                wrap
                justify-center
                pt-4
                style="font-size: 14px; color: #ababab"
              >
                <v-flex xs12 sm12 text-left px-2>
                  <span class="pl-3">Promo Code </span>
                  <v-text-field
                    ref="Promo Code"
                    color="#828282"
                    placeholder="Promo Code"
                    outlined
                    dense
                    v-model="couponData.promoCode"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 text-left px-2>
                  <span class="pl-3"> Description </span>
                  <v-text-field
                    ref="Description"
                    color="#828282"
                    placeholder="Description"
                    outlined
                    dense
                    v-model="couponData.description"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 text-left px-2>
                  <span class="pl-3"> Discount Percentage </span>
                  <v-text-field
                    ref="Discount Percentage"
                    color="#828282"
                    placeholder="Discount Percentage"
                    outlined
                    dense
                    v-model="couponData.discountPercentage"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 text-left px-2>
                  <span class="pl-3"> From Date </span>
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :return-value.sync="couponData.validFromDate"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="couponData.validFromDate"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        outlined
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="couponData.validFromDate"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="menu = false">
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu.save(couponData.validFromDate)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm6 text-left px-2>
                  <span class="pl-3"> To Date </span>
                  <v-menu
                    ref="menu1"
                    v-model="menu1"
                    :close-on-content-click="false"
                    :return-value.sync="couponData.validToDate"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="couponData.validToDate"
                        outlined
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="couponData.validToDate"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="menu1 = false">
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu1.save(couponData.validToDate)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-flex>
              </v-layout>
              <v-layout wrap justify-center>
                <v-flex xs6 px-2>
                  <v-btn
                    :ripple="false"
                    depressed
                    block
                    tile
                    color="#F9F9F9"
                    @click="dialog = false"
                  >
                    <span
                      style="
                    font-family: poppinssemibold;
                    font-size: 12px;
                    color: #000;
                    text-transform: none;
                  "
                    >
                      Cancel
                    </span>
                  </v-btn>
                </v-flex>
                <v-flex xs6 px-2>
                  <v-btn
                    :ripple="false"
                    depressed
                    block
                    tile
                    color="#3ea56e"
                    @click="addPromoCode()"
                  >
                    <span
                      style="
                    font-family: poppinssemibold;
                    font-size: 12px;
                    color: #fff;
                    text-transform: none;
                  "
                    >
                      Save
                    </span>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteDialogue" width="400">
      <v-card>
        <v-layout pa-4 wrap justify-center>
          <v-flex xs12>
            <span
              style="
                color: #000000;
                font-family: opensanssemibold;
                font-size: 18px;
              "
              >Do you want to delete this promo code ?</span
            >
          </v-flex>
          <v-flex xs6 px-2>
            <v-btn
              tile
              block
              depressed
              dark
              color="#ff1313"
              @click="deletePromo"
            >
              <span style="font-family: poppinsregular; font-size: 14px">
                Yes
              </span>
            </v-btn>
          </v-flex>
          <v-flex xs6 px-2>
            <v-btn
              tile
              block
              depressed
              dark
              color="#1BD93B"
              @click="deleteDialogue = false"
            >
              <span style="font-family: poppinsregular; font-size: 14px">
                No
              </span>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
// import PromoCodeList from "./promoCodeList.vue";
export default {
  props: ["productData", "productPhotos"],
  // components: {
  //   PromoCodeList,
  // },
  data() {
    return {
      appLoading: false,
      showSnackBar: false,
      timeout: 5000,
      ServerError: false,
      dialog: false,
      editDialog: false,
      msg: null,
      deleteDialogue: false,
      colors: [
        { color: "#C2C2C2", quantity: 23 },
        { color: "#EE2749", quantity: 87 },
        { color: "#000000", quantity: 12 },
        { color: "#5E0C0C", quantity: 32 },
        { color: "#4251D1", quantity: 241 },
        { color: "#4251D1", quantity: 241 },
      ],
      menu1: false,
      menu: false,
      coupon: [],
      editingitem: "",
      couponData: {
        discountPercentage: null,
        promoCode: null,
        description: "",
        validFromDate: new Date().toISOString().substr(0, 10),
        validToDate: new Date().toISOString().substr(0, 10),
      },
      productSize: {},
      selectedProduct: {},
      curImage: null,
      statusLoading: false,
    };
  },
  beforeMount() {
    if (this.productData) {
      this.getData();
    }
  },
  methods: {
    showImage(item) {
      this.curImage = item;
    },
    changeSize(item) {
      this.productSize = item;
    },
    selectProduct(item) {
      this.selectedProduct = item;
    },
    promoCode() {
      if (this.productData.offer > 0) {
        this.msg =
          "This product already have an offer. You can only add promo code for a product with no offer";
        this.showSnackBar = true;
      } else this.dialog = true;
    },
    getData() {
      this.appLoading = true;
      axios({
        url: "/product/promocode/list",
        method: "GET",
        params: {
          productId: this.$route.params.id,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.coupon = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    changePromoStatus(item) {
      this.statusLoading = true;

      axios({
        method: "POST",
        url: "/product/promocode/change/status",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          id: item._id,
        },
      })
        .then((response) => {
          this.statusLoading = false;
          if (response.data.status) {
            this.msg = "Product Status Changed";
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.statusLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    addPromoCode() {
      this.couponData.productId = this.productData._id;
      axios({
        url: "/product/add/promocode",
        method: "POST",
        data: this.couponData,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.getData();
            this.msg = "Added Sucessfully";
            this.showsnackbar = true;
            this.dialog = false;
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    editPromoCode() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/product/edit/promocode",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          description: this.editingitem.description,
          id: this.editingitem._id,
          promoCode: this.editingitem.promoCode,
          validFromDate: this.editingitem.validFromDate,
          validToDate: this.editingitem.validToDate,
          discountPercentage: this.editingitem.discountPercentage,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.getData();
            this.msg = "Edited Sucessfully";
            this.showsnackbar = true;
            this.editDialog = false;
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    deletePromo(item) {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/product/promocode/delete",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          id: item._id,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Product Deleted Successfully";
            this.showSnackBar = true;
            this.getData();
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },
    editItem(item) {
      this.editingitem = item;
      console.log(this.editingitem);
      this.editDialog = true;
      this.editingitem.validFromDate = this.editingitem.validFromDate.slice(
        0,
        10
      );
      this.editingitem.validToDate = this.editingitem.validToDate.slice(0, 10);
    },
  },
};
</script>
<style scoped>
.colorselector.v-sheet.v-card {
  border-radius: 35px;
}
.sizebutton.v-btn:not(.v-btn--round).v-size--small {
  /* min-width: 50px; */
  padding: 0 12px !important;
  min-width: 30px !important;
}

.modern-card { background: #ffffff; border: 1px solid #eaedf0; border-radius: 12px; overflow: visible; box-shadow: 0 4px 12px rgba(0, 0, 0, 0.02) !important; }

.main-image-wrapper { background: #f8fafc; border-radius: 8px; padding: 16px; border: 1px solid #f1f5f9; display: flex; justify-content: center; align-items: center; min-height: 400px; }
.thumbnail-row { display: flex; gap: 12px; flex-wrap: wrap; justify-content: center; }
.thumbnail-wrapper { width: 80px; height: 80px; border-radius: 8px; border: 2px solid transparent; cursor: pointer; overflow: hidden; background: #f8fafc; transition: all 0.2s ease; }
.thumbnail-wrapper:hover { border-color: #cbd5e1; }
.thumbnail-wrapper.active-thumb { border-color: #3ea56e; }

.section-title { font-size: 18px; font-weight: 600; color: #1e293b; font-family: poppinssemibold, sans-serif; margin: 0; }

.info-list { display: flex; flex-direction: column; gap: 12px; }
.info-list-row { display: flex; justify-content: space-between; align-items: center; padding-bottom: 12px; border-bottom: 1px solid #eaedf0; }
.info-list-row:last-child { padding-bottom: 0; border-bottom: none; }
.info-label { font-size: 13px; color: #64748b; text-transform: uppercase; letter-spacing: 0.5px; font-family: poppinsmedium, sans-serif; }
.info-value { font-size: 15px; color: #1e293b; font-weight: 600; font-family: poppinssemibold, sans-serif; }
</style>
